import React, { memo, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Range } from 'react-date-range';
import { useGetBpsAdminDashboardChartQuery, useGetBpsAdminDashboardQuery } from '../../../service/bps-admin-service';
import styles from './AdminDashboard.module.scss'
import CommonLoadingSpinnerForPage from '../../../common/components/loading-spinner/CommonLoadingSpinnerForPage'
import AdminDashboardCards from './components/AdminDashboardCards'
import AdminLoansDashboardSection from './components/AdminLoansDashboardSection'
import AdminDashboardChart from './components/AdminDashboardChart'
import { useConfigLayout } from '../../../hooks/useConfigLayout';

type Props = {}

const AdminDashboard: React.FC<Props> = memo((props: Props) => {
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    useConfigLayout({
                showCountrySelector: false,
                utility: null,
                showExportButton: false,
                showBreadCrumb: false,
                exportHandler: () => {},
            });

    const [range, setRange] = useState<Range>({
        startDate: firstDay,
        endDate: lastDay,
        key: 'selection',
        showDateDisplay: false
    })

    const { 
        data,
        isLoading: isLoadingDashboard,
        error: dashboardError
    } = useGetBpsAdminDashboardQuery();

    const { 
        data: chartData,
        isLoading: isLoadingChartData,
        error: chartError
    } = useGetBpsAdminDashboardChartQuery({
        startDate: range.startDate!,
        endDate: range.endDate!
    });

    useEffect(() => {
        if (dashboardError) {
            toast.error("There was an error fetching dashboard data");
        }
        if (chartError) {
            toast.error("There was an error fetching chart data");
        }
    }, [dashboardError, chartError]);

    const handleDateRangeChange = (range: Range) => {
        if (range.startDate && range.endDate) {
            if (range.startDate.getTime() === range.endDate.getTime()) return;
            setRange(range);
        }
    }

     

    return (
        <div className={styles.container}>
            <div className={`${styles.headerSection} ${styles.standardSectionPadding}`}>
                <div className={styles.text}>
                    General Overview
                </div>
            </div>
            <div className={`${styles.welcomeSection} ${styles.standardSectionPadding}`}>
                <b>Welcome,</b> Admin
            </div>
            <CommonLoadingSpinnerForPage loading={isLoadingDashboard}>
            <div className={styles.standardSectionPadding}>
                <AdminDashboardCards data={data} />
            </div>
            <div className={styles.standardSectionPadding}>
                <AdminLoansDashboardSection data={data}/>
            </div>
            </CommonLoadingSpinnerForPage>
            <CommonLoadingSpinnerForPage loading={isLoadingChartData}>
                <AdminDashboardChart chartData={chartData} range={range} handleDateRangeChange={handleDateRangeChange} />
            </CommonLoadingSpinnerForPage>
        </div>
    )
})

export default AdminDashboard